var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
var WaterDrop = function (props) { return (React.createElement("svg", __assign({ viewBox: "0 0 662.51 1024.01", width: "1em", height: "1em" }, props),
    React.createElement("defs", null),
    React.createElement("g", { id: "Layer_2", "data-name": "Layer 2" },
        React.createElement("g", { id: "icon" },
            React.createElement("path", { className: "cls-1", d: "M624.51 538.78l-4.51-8.67c-36-68.43-73.2-139.19-108.33-209.35l-87.8-175.26a32 32 0 0 0-57.23 28.66l87.75 175.25c35.41 70.74 72.78 141.78 108.91 210.49l4.56 8.67c52.48 99.78 36.3 222.54-40.25 305.47a266.93 266.93 0 0 1-392.71 0c-76.55-82.93-92.73-205.69-40.25-305.47l4.56-8.67c36.13-68.71 73.5-139.75 108.91-210.49L359.87 46.33a32 32 0 1 0-57.23-28.65L150.89 320.76c-35.13 70.16-72.34 140.92-108.33 209.35L38 538.78a331.2 331.2 0 0 0 536.64 378.67 331.3 331.3 0 0 0 49.87-378.67z" }),
            React.createElement("path", { className: "cls-1", d: "M166.19 570A32 32 0 0 0 123 583.46a235.53 235.53 0 0 0 35.45 268.87 32 32 0 1 0 47-43.41 171.42 171.42 0 0 1-25.83-195.67A32 32 0 0 0 166.19 570z" }))))); };
export default WaterDrop;
//# sourceMappingURL=WaterDrop.js.map